import { makeAutoObservable } from "mobx";

class Store {
  private _loading: boolean = false;
  private _message: string = "";
  private _autoHideDuration: number | undefined = 6000; // undefined deixa sem autohide
  private _status: "success" | "error" | "warning" | "info" | "default" =
    "default";
  private _openIntegration: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  get message() {
    return this._message;
  }

  get status() {
    return this._status;
  }

  get autoHideDuration() {
    return this._autoHideDuration;
  }

  get isLoading() {
    return this._loading;
  }

  getShowIntegration() {
    return this._openIntegration;
  }

  error = (newMessage: string, cancelAutoHide: boolean = true) =>
    this.setMessage(newMessage, "error", cancelAutoHide);

  warning = (newMessage: string, cancelAutoHide: boolean = false) =>
    this.setMessage(newMessage, "warning", cancelAutoHide);

  success = (newMessage: string, cancelAutoHide: boolean = false) =>
    this.setMessage(newMessage, "success", cancelAutoHide);

  info = (newMessage: string, cancelAutoHide: boolean = false) =>
    this.setMessage(newMessage, "info", cancelAutoHide);

  toggleLoading() {
    this._loading = !this._loading;
  }

  public setLoading(loading: boolean) {
    this._loading = loading;
  }

  openIntegrationMessage() {
    this._openIntegration = true;
  }

  closeIntegrationMessage() {
    this._openIntegration = false;
  }

  private setMessage(
    newMessage: string,
    status: "success" | "error" | "warning" | "info" | "default",
    cancelAutoHide: boolean = false
  ) {
    this._message = newMessage;
    this._status = status;
    this._autoHideDuration = cancelAutoHide ? undefined : 6000;
  }

  public clearMessage() {
    this._message = "";
    this._autoHideDuration = 6000;
    this._status = "default";
  }
}

const MessageStore = new Store();
export default MessageStore;
